export const querySelector = (state) => state?.router?.location?.query;
